import React from "react";
import { Routes, Route, Navigate, useParams, useLocation, useNavigate } from "react-router-dom";
import { I18nProvider, useI18n } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/Home";
import PrivacyPage from "@/pages/PrivacyPolicy";
import CookiesPage from "@/pages/CookiePolicy";
import TermsPage from "@/pages/TermsConditions";
import ThankYouPage from "@/pages/ThankYou";
import NotFoundPage from "@/pages/NotFound";

const VALID_LANGS = ["ar", "en"];

function LangLayout({ children }) {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  if (!VALID_LANGS.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }

  return (
    <I18nProvider lang={lang}>
      <MetaSync />
      <div className="min-h-screen flex flex-col bg-[#F5F3EF] text-[#1a1f2b]">
        <Header lang={lang} onSwitchLang={(nextLang) => {
          const rest = location.pathname.replace(/^\/(ar|en)/, "");
          navigate(`/${nextLang}${rest || ""}`, { replace: false });
        }} />
        <main className="flex-1">{children}</main>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function MetaSync() {
  const { t, lang } = useI18n();
  React.useEffect(() => {
    document.title = t("meta.title");
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", t("meta.description"));
    document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
  }, [t, lang]);
  return null;
}

function ThankYouWrapper() {
  return (
    <I18nProvider lang="ar">
      <div className="min-h-screen flex flex-col bg-[#F5F3EF] text-[#1a1f2b]">
        <ThankYouPage />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYouWrapper />} />
        <Route path="/:lang" element={<LangLayout><HomePage /></LangLayout>} />
        <Route path="/:lang/privacy" element={<LangLayout><PrivacyPage /></LangLayout>} />
        <Route path="/:lang/cookies" element={<LangLayout><CookiesPage /></LangLayout>} />
        <Route path="/:lang/terms" element={<LangLayout><TermsPage /></LangLayout>} />
        <Route path="*" element={<LangLayout><NotFoundPage /></LangLayout>} />
      </Routes>
    </>
  );
}
